<template>
  <input type="text" ref="input" v-model="value" v-mask="vmask" class="pci-date-editor text-center" />
</template>

<script>
import moment from 'moment'
import { mask } from 'vue-the-mask'
import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'DateEditor',
  directives: {mask},
  computed: {
    vmask () {
      return navigator.language === 'pt-BR' ? ['##/##/####'] : navigator.language === 'es-CL' ? ['##/##/####', '##/#/####', '#/##/####', '#/#/####'] : ['##-##-####']
    }
  },
  data () {
    return {
      value: null,
      cancelBeforeStart: true,
      highlightAllOnFocus: true
    }
  },
  created () {
    let startValue
    let highlightAllOnFocus = true

    if (this.params.eventKey === 'Backspace' || this.params.eventKey === 'Delete') {
      startValue = ''
    } else if (this.params.charPress) {
      startValue = this.params.charPress
      highlightAllOnFocus = false
    } else {
      startValue = this.params.value ? new Date(this.params.value).toLocaleDateString() : this.params.eventKey !== 'Delete' ? new Date().toLocaleDateString() : null
      if (this.params.eventKey === 'F2') {
        highlightAllOnFocus = false
      }
    }

    this.value = startValue
    this.highlightAllOnFocus = highlightAllOnFocus
    this.cancelBeforeStart = this.params.value === '#NA#' || this.params.value === '#NREF#'
  },
  beforeMount () {
    if (this.params.charPress) {
      this.$nextTick(() => {
        this.$refs.input.focus()
        const evt = new KeyboardEvent('keypress', {key: this.params.charPress})
        this.$refs.input.dispatchEvent(evt)
        this.value = this.params.charPress
      })
    // } else if (this.params.eventKey === 'Delete') {
    //   if (this.params.value === '#NA#') {
    //     this.params.stopEditing()
    //     return
    //   }
    //   this.value = null
      // this.$nextTick(() => {
      //   this.$refs.input.focus()
      //   this.$refs.input.select()
      // })
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.input) {
        this.$refs.input.focus()
        if (this.highlightAllOnFocus) {
          this.$refs.input.select()
        }
      }
    })
  },
  methods: {
    getValue () {
      if (this.value) {
        const date = this.getDate()
        if (date.isValid()) {
          return date.toDate().toISOString().substring(0, 10)
        }
      }
    },
    getDate () {
      const mt1 = this.value.match(/^\d\d\/\d\d\/\d\d\d\d$/g)
      const mt2 = this.value.match(/^\d\d\/\d\d\/\d\d$/g)
      const mtx = this.value.match(/^\d\/\d\/\d\d\d\d$/g)
      const mty = this.value.match(/^\d\/\d\d\/\d\d\d\d$/g)
      const mtz = this.value.match(/^\d\d\/\d\/\d\d\d\d$/g)
      const mt3 = this.value.match(/^\d\d\/\d\d$/g)
      const mt4 = this.value.match(/^\d\/\d$/g)
      const mt5 = this.value.match(/^\d\d\/\d$/g)
      const mt6 = this.value.match(/^\d\/\d\d$/g)
      const mt7 = this.value.match(/^\d{2}-\d{2}-\d{4}$/g)

      let format
      let value = this.value

      if (mt1 || mt3) format = 'DD/MM/YYYY'
      if (mt2) format = 'DD/MM/YY'
      if (mt4 || mtx) format = 'D/M/YYYY'
      if (mt5 || mty) format = 'D/MM/YYYY'
      if (mt6 || mtz) format = 'DD/M/YYYY'
      if (mt7) format = 'DD-MM-YYYY'
      if (mt3 || mt4 || mt5 || mt6) {
        value = value + '/' + new Date().getFullYear()
      }

      return moment(value, format, true)
    },
    isCancelBeforeStart () {
      return this.cancelBeforeStart
    },
    isCancelAfterEnd () {
      if (this.value) {
        const mt1 = this.value.match(/^\d\d\/\d\d\/\d\d\d\d$/g)
        const mt2 = this.value.match(/^\d\d\/\d\d\/\d\d$/g)
        const mtx = this.value.match(/^\d\/\d\/\d\d\d\d$/g)
        const mty = this.value.match(/^\d\/\d\d\/\d\d\d\d$/g)
        const mtz = this.value.match(/^\d\d\/\d\/\d\d\d\d$/g)
        const mt3 = this.value.match(/^\d\d\/\d\d$/g)
        const mt4 = this.value.match(/^\d\/\d$/g)
        const mt5 = this.value.match(/^\d\/\d\d$/g)
        const mt6 = this.value.match(/^\d\d\/\d$/g)
        const mt7 = this.value.match(/^\d{2}-\d{2}-\d{4}$/g)

        let format
        let value = this.value

        if (mt1 || mt3) format = 'DD/MM/YYYY'
        if (mt2) format = 'DD/MM/YY'
        if (mt4 || mtx) format = 'D/M/YYYY'
        if (mt5 || mty) format = 'D/MM/YYYY'
        if (mt6 || mtz) format = 'DD/M/YYYY'
        if (mt7) format = 'DD-MM-YYYY'
        if (mt3 || mt4 || mt5 || mt6) {
          value = value + '/' + new Date().getFullYear()
        }

        const date = moment(value, format, true)
        if (!date.isValid()) {
          toast.error(this.$lang.Common.Alerts.InvalidDate)
          return true
        }
      }
      return false
    }
  }
}
</script>

<style scoped>
.pci-date-editor {
  border-width: 1px;
  border-style: solid;
  border-color: #babfc7;
  border-color: var(--ag-input-border-color, var(--ag-border-color, #babfc7));
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

.pci-date-editor:focus-visible {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/DateEditor.vue